import React from 'react'
import styled, { keyframes } from 'styled-components'
import { Subhead, Caption2 } from 'src/Styles/text-styles'
import { theme } from 'src/Styles/theme'

const Row = styled.div`
  display: flex;
  flex-direction: row;
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
`

const Title = styled(Subhead)`
  font-weight: 500;
  padding-left: 32px;
  padding-top: 4px;
  padding-bottom: 4px;
`
const CardDescription = styled(Caption2)`
  font-weight: 400;
  padding-left: 32px;
  padding-top: 6px;
  padding-bottom: 6px;
`

const spinAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
`

const Loader = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
  align-items: center;
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid ${theme.colors.primary};
  width: 25px;
  height: 25px;
  -webkit-animation: ${spinAnimation} 2s linear infinite;
  animation: ${spinAnimation} 2s linear infinite;
`

interface Props {
  title: string
  description?: string
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
}

const InnerCard = ({ title, description, Icon }: Props) => {
  const showData = () => {
    if (title && description) {
      return (
        <Row style={{ alignItems: 'center' }}>
          <Icon width={28} height={28} />
          <Col>
            <Title>{title}</Title>
            <CardDescription>{description}</CardDescription>
          </Col>
        </Row>
      )
    } else {
      return <Loader />
    }
  }
  return showData()
}

export default InnerCard
